import { render, staticRenderFns } from "./SearchNotices.vue?vue&type=template&id=1ce4238a&scoped=true"
import script from "./SearchNotices.vue?vue&type=script&lang=js"
export * from "./SearchNotices.vue?vue&type=script&lang=js"
import style0 from "./SearchNotices.vue?vue&type=style&index=0&id=1ce4238a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce4238a",
  null
  
)

export default component.exports